import { render, staticRenderFns } from "./BlackListRequestController.vue?vue&type=template&id=78e43d00&scoped=true"
import script from "./BlackListRequestController.vue?vue&type=script&lang=ts"
export * from "./BlackListRequestController.vue?vue&type=script&lang=ts"
import style0 from "./BlackListRequestController.vue?vue&type=style&index=0&id=78e43d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e43d00",
  null
  
)

export default component.exports